
































import { defineClassComponent } from '@/hooks'
import { navigateTo } from '@/router'
import { ref } from '@vue/composition-api'

export default defineClassComponent<{
  value: any[]
  foldable?: boolean
  clickable?: boolean
}>(
  {
    props: ['value', 'foldable', 'clickable'],
  },
  ({ props }) =>
    class {
      isFold = ref(!!props.foldable)

      handleGoodsClick = (goodsId: string) => {
        navigateTo('BookGoodsIndex', { goodsId })
      }
    },
)
